import React, { useEffect, useState } from "react";

const DateTimePopup = ({ media, onSave, onClose }) => {

    const [name, setName] = useState("");
    const [dateFormat, setDateFormat] = useState("dd/MM/yyyy");
    const [timeFormat, setTimeFormat] = useState("HH:mm:ss");
    const [showDate, setShowDate] = useState(true);
    const [showTime, setShowTime] = useState(true);
    const [timezone, setTimezone] = useState("Local");
    const [duration, setDuration] = useState(0);

    useEffect(() => {

        if (media) {
            setName(media.name);
            setDateFormat(media.dateFormat || "dd/MM/yyyy");
            setTimeFormat(media.timeFormat || "HH:mm:ss");
            setShowDate(media.showDate ?? true);
            setShowTime(media.showTime ?? true);
            setTimezone(media.timezone || "Local");
            setDuration(media.duration || 0);
        }

    }, [media]);

    const handleSave = () => {

        onSave({
            id: media?.id || null,
            name,
            dateFormat,
            timeFormat,
            showDate,
            showTime,
            timezone,
            duration
        });

    };

    return (
        <div className="popup-overlay">
            <div className="popup-content" style={{ width: 600 }}>

                <h2>{media ? "Edit Date & Time" : "Add Date & Time"}</h2>

                <div className="form-group">
                    <label>Name</label>
                    <input
                        className="form-control"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                </div>

                <div className="form-group">
                    <label>Date Format</label>
                    <select
                        className="form-control"
                        value={dateFormat}
                        onChange={(e) => setDateFormat(e.target.value)}
                    >
                        <option>dd/MM/yyyy</option>
                        <option>MM/dd/yyyy</option>
                        <option>yyyy-MM-dd</option>
                        <option>dddd, dd MMM yyyy</option>
                    </select>
                </div>

                <div className="form-group">
                    <label>Time Format</label>
                    <select
                        className="form-control"
                        value={timeFormat}
                        onChange={(e) => setTimeFormat(e.target.value)}
                    >
                        <option>HH:mm:ss</option>
                        <option>HH:mm</option>
                        <option>hh:mm:ss A</option>
                        <option>hh:mm A</option>
                    </select>
                </div>

                <div className="form-group">
                    <label>Timezone</label>
                    <select
                        className="form-control"
                        value={timezone}
                        onChange={(e) => setTimezone(e.target.value)}
                    >
                        <option>Local</option>
                        <option>UTC</option>
                        <option>Asia/Kolkata</option>
                        <option>America/New_York</option>
                        <option>Europe/London</option>
                    </select>
                </div>

                <div className="form-check">
                    <input
                        type="checkbox"
                        checked={showDate}
                        onChange={(e) => setShowDate(e.target.checked)}
                    />
                    <label>&nbsp;Show Date</label>
                </div>

                <div className="form-check">
                    <input
                        type="checkbox"
                        checked={showTime}
                        onChange={(e) => setShowTime(e.target.checked)}
                    />
                    <label>&nbsp;Show Time</label>
                </div>

                <div className="form-group mt-3">
                    <label>Duration (0 = Always Visible)</label>
                    <input
                        type="number"
                        className="form-control"
                        value={duration}
                        onChange={(e) => setDuration(Number(e.target.value))}
                    />
                </div>

                <div className="form-buttons">
                    <button className="btn btn-success" onClick={handleSave}>
                        Save
                    </button>

                    &nbsp;

                    <button className="btn btn-primary" onClick={onClose}>
                        Cancel
                    </button>
                </div>

            </div>
        </div>
    );
};

export default DateTimePopup;